import { Editor, Element } from 'slate';
import { getAbove } from './get-above';

export function getBlockAbove<T extends Element>(editor: Editor, options?: Parameters<typeof getAbove>[1]) {
    return getAbove<T>(editor, {
        ...options,
        block: true,
    });
}
